// src/components/ui/button.jsx
import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cn } from "@/lib/utils"

const buttonVariants = {
  variant: {
    default: "bg-blue-500 hover:bg-blue-600 text-white",
    secondary: "bg-[#1a1a1a] hover:bg-[#222222] border border-[#2a2a2a] text-white",
    ghost: "text-[#a0a0a0] hover:text-white hover:bg-[#1a1a1a]",
    danger: "bg-red-500 hover:bg-red-600 text-white",
    outline: "bg-transparent hover:bg-[#1a1a1a] border border-[#2a2a2a] text-white",
  },
  size: {
    default: "h-9 px-4 py-2",
    sm: "h-8 px-3 text-xs",
    lg: "h-11 px-8",
    icon: "h-9 w-9",
  },
}

const Button = React.forwardRef(
  ({ className, variant = "default", size = "default", asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(
          "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium",
          "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/20",
          "disabled:pointer-events-none disabled:opacity-50",
          buttonVariants.variant[variant],
          buttonVariants.size[size],
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }